import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

interface WarningItem {
	reservation: number;
	slot: number;
	stop: string;
}

export interface UnlikDialogData {
	message: string;
	warnings: WarningItem[];
}

@Component({
	selector: 'app-unlink-transport-dialog',
	standalone: true,
	imports: [MatButton, MatDialogActions, MatDialogContent, MatDialogTitle],
	template: `<h2 mat-dialog-title>Ostrzeżenie</h2>
		<mat-dialog-content>
			W łączonym transporcie znajdują się miasta z rezerwacjami, które nie występują w rozdzielonych
			transportach.<br />
			Niektórzy pasażerowie mogą zostać bez przypisanego miasta wyjazdowego lub powrotnego.<br />
			Rezerwacje z możliwymi błędami:
			<ul>
				@for (item of data.warnings; track $index) {
					<li>Rezerwacja: {{ item.reservation }}, Miasto: {{ item.stop }}</li>
				}
			</ul>
		</mat-dialog-content>

		<mat-dialog-actions align="center" class="d-flex flex-column justify-content-center align-items-center">
			<p>Czy na pewno chcesz kontynuować?</p>
			<div>
				<button mat-raised-button color="warn" (click)="onCancel()">Nie</button>
				<button mat-raised-button color="primary" (click)="onConfirm()">Tak</button>
			</div>
		</mat-dialog-actions> `,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnlinkTransportDialogComponent implements OnInit {
	readonly data: UnlikDialogData = inject(MAT_DIALOG_DATA);
	private readonly dialogRef = inject(MatDialogRef<UnlinkTransportDialogComponent>);

	ngOnInit(): void {
		this.deduplicateWarningsByReservationAndStop();
	}

	onConfirm(): void {
		this.dialogRef.close(true);
	}

	onCancel(): void {
		this.dialogRef.close(false);
	}

	private deduplicateWarningsByReservationAndStop(): void {
		const uniqueKeys = new Set<string>();

		this.data.warnings = this.data.warnings.filter((warning) => {
			const key = this.generateWarningKey(warning);
			if (uniqueKeys.has(key)) {
				return false;
			}
			uniqueKeys.add(key);
			return true;
		});
	}

	private generateWarningKey(warning: WarningItem): string {
		return `${warning.reservation}-${warning.stop}`;
	}
}
